<div class="scroll-box">
  <div class="wrapper">
    <div class="description-grid header-padding">
      <div>
        <h4>What is your post about?</h4>
      </div>
      <div
        class="short-description"
        (click)="
          patchPostDescription(
            'Write a post about 5 most powerful GenAI use cases in the automotive industry'
          )
        "
      >
        Give me examples
      </div>
    </div>

    <form [formGroup]="workflowForm">
      <textarea
        formControlName="postDescription"
        placeholder="Write a short description here"
        maxlength="{{ postDescriptionMax }}"
        (blur)="updateWorkflow()"
      ></textarea>
      <span class="counter"
        >{{ postDescriptionCount }}/{{ postDescriptionMax }}</span
      >
    </form>

    <fieldset
      [disabled]="isLoading$().show"
      [ngClass]="{ blur: isLoading$().show, 'no-blur': !isLoading$().show }"
    >
      <div class="pt-5">
        <h4>File relevant to the content of the post</h4>
      </div>
      <div class="description-subheader">
        <p>
          The uploaded file will be used as part of the context when generating
          your LinkedIn post.
        </p>
      </div>

      <div class="pb-2">
        <div
          class="dropzone"
          fileDrop
          (filesChangeEmitter)="onFileChange($event)"
        >
          <div class="text-wrapper">
            <div class="centered">
              <mat-icon>file_upload</mat-icon>
              <input
                type="file"
                name="file"
                id="file"
                (click)="resetChangeDetection()"
                (change)="onFileChange($event.target['files'])"
              />
              <label for="file">
                Drag and drop your file or <span class="textLink">browse</span
                ><br />
                <div class="upload-subheader">
                  PostGenie accepts a single file up to 10MB in PDF, TXT, CSV,
                  or Word format, with a maximum content length of around 90,000
                  characters.
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <ng-container
        *ngFor="
          let f of stateSignal$().workflow.workflow.promptWorkflow
            ?.uploadedFiles;
          let ind = index
        "
      >
        <div class="outer-file">
          <div
            class="row description-grid left"
            [ngClass]="{
              'invalidFileItem invalidFileItemText': [
                'canceled',
                'failed'
              ].includes(f.status),
              fileItem: ['completed', 'queued', 'running'].includes(f.status)
            }"
          >
            <mat-expansion-panel
              [expanded]="panelOpenState == true"
              (opened)="panelOpenState = true"
              (closed)="panelOpenState = false"
              [disabled]="
                !stateSignal$().workflow.workflow.promptWorkflow?.aiResults?.fileSummary
              "
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <strong>{{ f.name }}</strong>
                </mat-panel-title>
                <mat-panel-description>
                  <ng-container
                    *ngIf="['canceled', 'failed'].includes(f.status)"
                    ><span> (invalid file)</span></ng-container
                  >
                </mat-panel-description>
              </mat-expansion-panel-header>
              <p class="pt-2 w-100">
                {{
                  stateSignal$().workflow.workflow.promptWorkflow?.aiResults?.fileSummary
                }}
              </p>
            </mat-expansion-panel>
          </div>
        </div>
        <div class="delete right text-center">
          <mat-icon class="pointer" (click)="deleteFile(f)">delete</mat-icon>
        </div>
      </ng-container>
    </fieldset>
  </div>
</div>

<div class="btn-container">
  <button class="btn btn-primary" type="submit" (click)="askGenAi()">
    Next
  </button>
</div>
